import type { paymentMethod } from './types'
import paymentMethodsData from '../../data/paymentMethods.json'

export class paymentMethodsService {
  async getPaymentMethodsList(): Promise<{ data: paymentMethod[] }> {
    const paymentMethodsList = paymentMethodsData.data
    return { data: paymentMethodsList }
  }
}

